import React, { useState, useEffect } from 'react';
import stockBall from '../icons/stock_ball.jpg';

/**
 * Componente de imagem inteligente que tenta múltiplas URLs se uma falhar
 * Especialmente útil para imagens do Google Drive que podem ter problemas de CORS
 */
export default function SmartImage({ 
  src, 
  alt = '', 
  style = {}, 
  driveFileId = null,
  onError = null,
  onLoad = null,
  fallbackSrc = stockBall,
  ...props 
}) {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [attemptedUrls, setAttemptedUrls] = useState(new Set());

  const generateAlternativeUrls = (fileId) => {
    if (!fileId) return [];
    
    return [
      `https://lh3.googleusercontent.com/d/${fileId}`,
      `https://drive.google.com/uc?id=${fileId}&export=view`,
      `https://drive.google.com/uc?id=${fileId}`,
      `https://drive.google.com/thumbnail?id=${fileId}&sz=w800`,
    ];
  };

  const extractFileId = (url) => {
    if (!url || typeof url !== 'string') return null;
    const match = url.match(/[/?]id=([a-zA-Z0-9_-]{20,})/);
    return match ? match[1] : null;
  };

  const handleImageError = () => {
    console.error('❌ Erro ao carregar imagem:', currentSrc);
    
    const fileId = driveFileId || extractFileId(currentSrc);
    
    if (fileId) {
      const alternativeUrls = generateAlternativeUrls(fileId);
      
      const nextUrl = alternativeUrls.find(url => !attemptedUrls.has(url) && url !== currentSrc);
      
      if (nextUrl) {
        console.log('🔄 Tentando URL alternativa:', nextUrl);
        setAttemptedUrls(prev => new Set([...prev, currentSrc]));
        setCurrentSrc(nextUrl);
        return;
      }
    }
    
    if (currentSrc !== fallbackSrc) {
      console.log('🔄 Usando imagem de fallback:', fallbackSrc);
      setCurrentSrc(fallbackSrc);
    }
    
    if (onError) {
      onError();
    }
  };

  const handleImageLoad = () => {
    console.log('✅ Imagem carregada com sucesso:', currentSrc);
    if (onLoad) {
      onLoad();
    }
  };

  // Reset quando src muda
  useEffect(() => {
    setCurrentSrc(src);
    setAttemptedUrls(new Set());
  }, [src]);

  return (
    <img
      src={currentSrc}
      alt={alt}
      style={style}
      onError={handleImageError}
      onLoad={handleImageLoad}
      {...props}
    />
  );
}
